import Vue from "vue";
import Vuelidate, { validationMixin } from "vuelidate";
import { minLength, required, sameAs } from "vuelidate/lib/validators";

import { mapActions, mapMutations } from "vuex";

import { AUTH_SET_NEW_PASSWORD } from "@/store/action-types";

import {
    AUTH_SHOW_POPUP_NEW_PASSWORD,
    POPUP_TEXT_CONTENT,
    SHOW_POPUP_TEXT_CONTENT,
} from "@/store/mutation-types";

Vue.use(Vuelidate);

export default {
    name: "set-new-password",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                password: "",
                password_confirmation: "",
                code: this.$route.query.code,
                email: this.$route.query.email,
            },
            validationErrors: {
                password: [],
                password_confirmation: [],
            },
        };
    },
    validations: {
        payload: {
            password: {
                required,
                minLength: minLength(10),
            },
            password_confirmation: {
                required,
                sameAsPassword: sameAs("password"),
            },
        },
    },
    watch: {
        "payload.password"() {
            let error = [];

            if (!this.$v.payload.password.required) {
                error.push(
                    this.$t("fieldRequired").replace(":name", this.$t("password"))
                );
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 10));
            }

            this.validationErrors.password = error;
        },
        "payload.password_confirmation"() {
            let error = [];

            if (!this.$v.payload.password_confirmation.required) {
                error.push(
                    this.$t("fieldRequired").replace(
                        ":name",
                        this.$t("passwordConfirm").toLowerCase()
                    )
                );
            }
            if (!this.$v.payload.password_confirmation.sameAsPassword) {
                error.push(this.$t("validationSameAs"));
            }

            this.validationErrors.password_confirmation = error;
        },
    },
    computed: {
        disableButton() {
            if (
                this.payload.password === "" ||
                this.payload.password_confirmation === ""
            ) {
                return true;
            } else {
                return false;
            }
        },
        errorsMessages() {
            let errors = [];
            for (let i in this.validationErrors) {
                this.validationErrors[i].forEach((e) => {
                    errors.push(e);
                });
            }
            return errors;
        },
    },
    methods: {
        ...mapActions({
            send: `auth/${AUTH_SET_NEW_PASSWORD}`,
        }),
        ...mapMutations({
            showPopup: `system/${SHOW_POPUP_TEXT_CONTENT}`,
            changePopupNewPassword: `auth/${AUTH_SHOW_POPUP_NEW_PASSWORD}`,
            changeContentPopup: `system/${POPUP_TEXT_CONTENT}`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.send(this.payload)
                    .then(() => {
                        this.changePopupNewPassword(false);
                        this.changeContentPopup({
                            title: this.$t("restorePassword"),
                            text: this.$t("successChangeProfilePassword"),
                        });
                        this.showPopup(true);
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            for (let field in error.response.data.errors) {
                                this.validationErrors[field] =
                                    error.response.data.errors[field];
                            }
                        }
                    });
            }
        },
    },
    destroyed() {},
};
